import {Component, Input} from '@angular/core';
import {CompanyResponse, EventTypeResponse} from '../../../../../../@shared/models/response.module';
import {EventsService} from '../../../../../../@shared/services/events-service';
import {_AQH_EVE_1, _AQH_EVE_5, AQH_EVE_1, AQH_EVE_4, AQH_EVE_5} from '../../../../../../@shared/models/input.module';

@Component({
  selector: 'app-add-event',
  standalone: false,
  templateUrl: './add-event.html',
  styleUrl: './add-event.css'
})
export class AddEvent {
  @Input() company: CompanyResponse
  eventTypes: EventTypeResponse[]

  event_name: string = ''
  event_description: string = ''
  event_type_id: EventTypeResponse
  start_date: string | null;
  end_date: string | null;
  address: string;
  postal_code: string;
  city: string;
  country: string;
  registration_deadline: string;
  logo?: File;
  header?: File;

  constructor(private eventService: EventsService) {
  }

  ngOnInit() {
    this.getEventTypes()
  }

  getEventTypes() {
    let params: AQH_EVE_4 = {}
    this.eventService.getEventTypes(params).subscribe((res) => {
      this.eventTypes = res
    })
  }

  addEvent() {
    console.log("Event_name:", this.event_name);
    console.log("Event_description:", this.event_description);
    console.log("Event_type_id:", this.event_type_id);
    console.log("Start_date:", this.start_date);
    console.log("End_date:", this.end_date);
    console.log("Address:", this.address);
    console.log("Postal_code:", this.postal_code);
    console.log("City:", this.city);
    console.log("Country:", this.country);
    console.log("Registration_deadline:", this.registration_deadline);
    console.log("Logo:", this.logo);
    console.log("Header:", this.header);

    let params: _AQH_EVE_1 = {
      event_name: this.event_name,
      event_description: this.event_description,
      event_type_id: this.event_type_id.event_type_id,
      start_date: this.start_date!,
      end_date: this.end_date!,
      registration_deadline: this.registration_deadline,
      address: this.address,
      postal_code: this.postal_code,
      city: this.city,
      country: this.country,
    }
    this.eventService.addEvent(params).subscribe((res) => {
      console.log("Event added:", res.data);
      if (this.logo) {
        let logoParams: _AQH_EVE_5 = {
          event_id: res.data.event_id,
          image_type: 'logo',
          image: this.logo
        }
        this.eventService.editEventFiles(logoParams).subscribe((logoRes) => {
          console.log("Logo uploaded:", logoRes);
        })
      }
      if (this.header) {
        let headerParams: _AQH_EVE_5 = {
          event_id: res.data.event_id,
          image_type: 'header',
          image: this.header
        }
        this.eventService.editEventFiles(headerParams).subscribe((headerRes) => {
          console.log("Header uploaded:", headerRes);
        })
      }
    })
  }
}
